import css from "styled-jsx/css";
import { MODAL_BACKGROUND } from "/constants/z-index";

const closeButtonWidth = 32;
const closeButtonHeight = closeButtonWidth + "px";

export const styles = css.global`
  .preview-image-container {
    z-index: ${MODAL_BACKGROUND + 100};
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);

    .container-with-close {
      max-width: 70%;
      margin: auto;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;

      .header {
        display: flex;
        flex: 0 0 40px;
        width: 100%;

        justify-content: flex-end;
        .close {
          top: 40px;
          margin-right: -40px;
          position: relative;
          width: ${closeButtonHeight};
          height: ${closeButtonHeight};
          opacity: 0.8;
        }
        .close:hover {
          opacity: 1;
        }
        .close:before,
        .close:after {
          position: absolute;
          left: 15px;
          content: " ";
          height: 33px;
          width: 2px;
          background-color: white;
        }
        .close:before {
          transform: rotate(45deg);
        }
        .close:after {
          transform: rotate(-45deg);
        }
      }
      .image-figure {
        height: 100vh;
        display: inline-block;
        text-align: center;
        margin: 0;
        .preview-image {
          max-height: 85%;
          max-width: 90%;
          width: auto; // keep aspect ratio
          height: auto;
        }

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;
